export default __webpack_public_path__ + "static/media/Plus.f89fb61e.svg";